const ContactUsData = {
    heading: `Contact Us`,
    content: <>
        <h3>Are you ready to blow your mind?</h3>
        <p>Then drop in your message and we will get in touch with you ASAP</p>
    </>,
    btnText: `Send message!`
};

export default ContactUsData;